import Select from 'react-select/async';

import styled, { css } from 'styled-components';

export type SelectVariant = 'default' | 'outlined';

interface ContainerProps {
  addNew?: 'none' | 'multi' | 'single';
}

interface StyledSelectProps {
  hasError: boolean;
  variant: SelectVariant;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;

  ${({ addNew }) =>
    addNew === 'none'
      ? css`
          width: 100% !important;
          > div {
            width: 100% !important;
          }
        `
      : css`
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          gap: ${({ theme }) => theme.spacing.xs};

          > div:first-of-type {
            width: 100%;
          }

          > div:last-of-type {
            width: ${addNew === 'single' ? '50px' : '100px'};
            > div {
              width: 50px;
            }
          }
        `}

  #button {
    button {
      padding: 0;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const StyledSelect = styled(Select)<StyledSelectProps>`
  .react-select__control {
    min-height: 48px;
    cursor: pointer !important;

    ${({ theme, variant, hasError }) =>
      variant === 'default'
        ? css`
            border: none;
            border-bottom: ${`2px solid ${
              hasError ? theme.colors.error : theme.colors.primary
            }`};
            border-radius: 0;

            &:hover {
              border-color: ${hasError
                ? theme.colors.error
                : theme.colors.primary};
            }
          `
        : css`
            border: 1px solid ${hasError ? theme.colors.error : '#ddd'};
            border-radius: ${theme.borderRadius.md};

            &:hover {
              border-color: ${hasError ? theme.colors.error : '#ddd'};
            }
          `}
  }

  ${({ variant }) =>
    variant === 'default' &&
    css`
      .react-select__control--is-disabled {
        background: ${({ theme }) => theme.colors.surface};
        border-color: #dcdcdc;

        .react-select__indicator {
          color: #ccc;
        }

        .react-select__input,
        .react-select__value-container,
        .react-select__placeholder {
          filter: opacity(0.5);
        }
      }
    `}

  .react-select__control--is-focused {
    box-shadow: none;
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.error : theme.colors.primary};

    &:hover {
      border-color: ${({ theme, hasError }) =>
        hasError ? theme.colors.error : theme.colors.primary};
    }

    .react-select__single-value {
      font-weight: 400;
      font-size: 15px;
      letter-spacing: 0px;
      color: ${({ theme }) => theme.colors.onSurface};
    }

    .react-select__input {
      color: ${({ theme }) => theme.colors.onSurface};
      font-weight: 400;
      font-size: 15px;
      letter-spacing: 0px;
    }

    .react-select__indicator {
      color: ${({ theme, hasError }) =>
        hasError ? theme.colors.error : theme.colors.primary};
    }
  }

  .react-select__placeholder {
    color: ${({ theme }) => theme.colors.onSurface};
    white-space: nowrap;
    font-weight: 400;
    font-size: 15px;
    letter-spacing: 0px;
    filter: opacity(0.4);
  }

  .react-select__value-container {
    font-size: 15px;
    letter-spacing: 0px;
    font-weight: 400;
    font-weight: 500;
    padding: ${({ theme, variant }) =>
      `0 ${variant === 'default' ? 0 : theme.spacing.xs}`};
    white-space: nowrap;
    overflow: hidden;
  }

  .react-select__option {
    background: ${({ theme }) => theme.colors.surface};
    display: flex;
    align-items: center;
    z-index: 200;
    padding: 8px 12px;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__indicator {
    color: ${({ theme, hasError }) =>
      hasError ? theme.colors.error : theme.colors.onSurface};

    padding: ${({ theme }) => theme.spacing.xs}px;
    padding-right: ${({ theme, variant }) =>
      variant === 'default' ? 0 : theme.spacing.xs};
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

export const AddNewArrayContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs};
`;
